import React from 'react'
import { useTranslation } from "react-i18next"
import { Link } from 'react-router-dom'
import { Container, Grid, useMediaQuery } from '@material-ui/core'
import { SimpleLoading, PromotionalFooterPure } from '../../pures'

const ValidationSignedDocumentsDetailView = (props) => {
  const { t } = useTranslation()
  const longmatches = useMediaQuery('(max-width:1200px)')

  const globalContainerStyles = {
    display: 'inline-block',
    justifyContent: 'flex-start',
    maxWidth: '100%',
    backgroundColor: 'white',
    width: 'auto'
  }
  if (longmatches) {
    globalContainerStyles.marginRight = 0
  }

  return (
    <div className='standard-wrapper'>
      {(props.loading) ? <SimpleLoading /> :
        <Container spacing={4} sm={12} xs={12} lg={12} md={12} style={globalContainerStyles}>
          <Container es={12} className='table-card-queriesValidations' >
            <div className="table-queriesValidations" xs={12} lg={12} md={12} sm={12}>
              <h3 className="table-title-queriesValidations">{t('queriesAndValidationsView.validationsSignedDocuments')}</h3>
            </div>
            <Grid container className='queriesValidations-container' xs={12} lg={12} md={12} sm={12} es={12}>
              <Grid container xs={6} lg={12} md={12} sm={12} es={12} className='container-cards-queriesValidations'>

              </Grid>
              <Grid item xs={12} lg={12} md={12} sm={12} es={12} className='btn-back-queriesValidations'>
                <Link to='/queries-and-validations' >
                  <button onClick={props.scrollWindow} className='back-style-queriesValidations'>{t('queriesAndValidationsView.buttonBack')}</button>
                </Link>
              </Grid>
              <Grid item xs={12} lg={12} md={12} sm={12} es={12} >
                <PromotionalFooterPure />
              </Grid>
            </Grid>
          </Container>
        </Container>
      }
    </div>
  )
}

export { ValidationSignedDocumentsDetailView as default }